import { IAuthorizedTenant } from "../models/user-profile.model";

export const getUniqueFacilityIds = (tenants: IAuthorizedTenant[]): IAuthorizedTenant["tenantId"][] =>
	 tenants
		.map((x) =>  x.tenantId)
		.filter((id, index, arr) => arr.indexOf(id) === index); // dedupe

export const getTenantLabel = (
	tenant: IAuthorizedTenant,
	authorizedTenants: IAuthorizedTenant[]
): string => {
	const facilityIds = getUniqueFacilityIds(authorizedTenants);
	const separator = ' \u2013 '; // " – "
	const combinedLabel = `${tenant.facilityName}${separator}${tenant.tenantName}`;

	if (facilityIds && facilityIds.length > 1) {
		// Check if the tenantName already contains the combined format to prevent double-labeling.
		if (tenant.tenantName.includes(combinedLabel)) {
			return tenant.tenantName;
		}
	}

	return combinedLabel;
};
